module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/links/links.component.html
// module id = ./src/app/links/links.component.html
// module chunks = main